import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import FormControl from "@mui/material/FormControl";
import SignaturePad from "signature_pad";

import { StyledFormHelperText } from "./CommonStyled";
import { IssueData } from "../../Utilities/ControlRenderContext";
import { DataFormControl } from "../DataFormControl";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";
import type { AppGlueAny } from "../../../rule-engine-core/Common/AppGlueAny";

const SignPadCanvas = React.forwardRef<any, any>((props: any, ref) => {
    const signaturePad = useRef<AppGlueAny>();

    const handleChange = () => {
        if (props.control.valueName) {
            props.control.setFormDataValue(props.control.valueName, signaturePad.current.toDataURL());
        }
    };

    useEffect(() => {
        let canvas: HTMLCanvasElement | null = document.querySelector("canvas");
        signaturePad.current = canvas ? new SignaturePad(canvas) : null;
        if (signaturePad.current) signaturePad.current.afterUpdateStroke = handleChange;
    }, []);

    return <StyledCanvas ref={ref} />;
});

class XSignaturePadEditUI extends React.Component<{ editMe: SignaturePadFormControl }> {
    render() {
        return <UISpacedBoxContent>{this.props.editMe.renderBaseDataControlEditor()}</UISpacedBoxContent>;
    }
}

export class SignaturePadFormControl extends DataFormControl {
    readonly __type: string = "Signature Pad";

    render() {
        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";

        return (
            <>
                {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                <FormControl
                    variant="outlined"
                    error={Boolean(issueText)}
                >
                    <SignPadCanvas
                        control={this}
                        ref={this.ref}
                    />
                    {issueText && (
                        <StyledFormHelperText
                            error={Boolean(issueText)}
                            data-testid={`${this.valueName}`}
                        >
                            {issueText}
                        </StyledFormHelperText>
                    )}
                </FormControl>
            </>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XSignaturePadEditUI editMe={this} />;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new StringDataDefinition();
        def.name = this.valueName;
        return def;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type");
    }
}

const StyledCanvas = styled.canvas`
    width: 300px;
    height: 100px;

    border-radius: 4px;
    border: 1px solid ${UIStyleConstants.GRAY_COLOR};
`;
